declare global {
  var twq: Function;
}

export const reportSignupToTwitter = (email: string) => {
  if (process.env.NODE_ENV === "production" && twq) {
    try {
      twq('event', 'tw-ofiup-ofivd', {
        email_address: email
      });
    } catch(e) {
      console.error(e);
    }
  }
};

export const reportPurchaseToTwitter = () => {  
  if (process.env.NODE_ENV === "production" && twq) {
    try {
      twq('event', 'tw-ofiup-ofivf', {
        value: 20
      });
    } catch(e) {
      console.error(e);
    }
  }
};